<div class="container-fluid main-body full">
  <router-outlet></router-outlet>
</div>
